import { useSearchParams } from 'react-router-dom';

function useGetCurrentPage(): number {
  const [searchParams] = useSearchParams();
  return parseInt(searchParams.get('page') || '1', 10);
}

export default useGetCurrentPage;
